import React from 'react';
import './MaintenanceScreen.css'

/**
 * Event Screen
 */
class MaintenanceScreen extends React.Component {
  render() {
    return (
      <div id="maintenance-screen">
      </div>
    )
  }
}

export default MaintenanceScreen;